import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { Stage, StageGetCollectionByProjectId, StageGetCollectionByProjectIdResponse } from '../../api/dtos';


const getData = (response?: SWRResponse<StageGetCollectionByProjectIdResponse, StageGetCollectionByProjectIdResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<StageGetCollectionByProjectIdResponse, StageGetCollectionByProjectIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<StageGetCollectionByProjectIdResponse, StageGetCollectionByProjectIdResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, Stage>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}): undefined,
    total: response?.data?.total
});

const useStagesByProjectId = (projectId?: number, skip?: number, take?: number, configuration?: SWRConfiguration<StageGetCollectionByProjectIdResponse, StageGetCollectionByProjectIdResponse>) => {
    
    const request = useMemo(() => {

        return projectId ?
            () => {
                return new StageGetCollectionByProjectId({ projectId, skip, take });
            } :
            undefined;
    }, [projectId, skip, take])

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useStagesByProjectId;